import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() minDate: Date = null;
  @Input() detailMode: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  getError(errorCode: string) {
    // Enables the control for getting the error properly

    this.formGroup.get(this.controlName).enable();
    const hasError: boolean = this.formGroup.get(this.controlName).hasError(errorCode);
    this.formGroup.get(this.controlName).disable();
    return hasError;
  }

}
